export default __webpack_public_path__ + "static/media/faq-card-image.49253b3a.jpg";